export default "__VITE_ASSET__Esd4yBst__"